module.exports = __webpack_public_path__ + "img/default-EFT.408dd174.svg";